<template>
  <div class="home-page">
    <!-- ===== 02 Hero 主视觉区 · 强化行业定位 ===== -->
    <section class="relative bg-por">
        <div class="max-w-6xl mx-auto px-4 sm:px-4 lg:px-6 md:py-12">
            <div class="grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h1 style="color: #0E1F52;">
                        央企国企<span class="text-[#1F3F8F]">数字转型咨询</span><br>审计 · 风控 · 合规 · 数据治理 AI及大模型
                    </h1>
                    <p class="mt-6 text-xl text-black max-w-6xl">
                        专注于能源电力，制造业及集团型企业，提供审计风控合规，数据治理，AI及大模型(LLM)，数字化转型规划，AI及数据管理领域培训的数字化解决方案。
                    </p>

                    <!-- 关键词云（SEO强化） -->
                    <div class="rc-keyword-cloud">
                        <h2 class="rc-keyword-tag highlight">内部审计</h2>
                        <h2 class="rc-keyword-tag">风险管理</h2>
                        <h2 class="rc-keyword-tag">数智审计</h2>
                        <h2 class="rc-keyword-tag">风险预警系统</h2>
                        <h2 class="rc-keyword-tag">内部审计系统</h2>
                        <h2 class="rc-keyword-tag">审计管理平台</h2>
                        <h2 class="rc-keyword-tag">集团审计系统</h2>
                        <h2 class="rc-keyword-tag">穿透式风险</h2>
                        <h2 class="rc-keyword-tag">反舞弊系统</h2>
                        <h2 class="rc-keyword-tag">AI智能体</h2>
                    </div>

                    <!-- 合作客户简标 -->
                    <div class="mt-10 flex items-center space-x-6 text-sm text-[#5A5E66]">
                        <span class="font-medium text-[#0E1F52]">服务50+央企国企</span>
                        <span class="w-px h-4 bg-divider"></span>
                        <span>国家能源集团</span>
                        <span>中国人寿</span>
                        <span>一汽集团</span>
                    </div>
                </div>

                <!-- 右侧列：主视觉图标 -->
                <div class="hidden md:flex justify-end pr-8">                                     <!-- 靠右并增加右内边距 -->
                    <div class="relative w-80 h-80 rounded-full bg-white shadow-xl flex items-center justify-center">
                        <span class="text-7xl text-[#1F3F8F] opacity-15">🏺</span>                <!-- 图标缩小 -->
                        <span class="absolute text-xl font-serif text-[#1F3F8F]">数据蓝脉</span>   <!-- 文字缩小 -->  
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- 新增：03 公司四块核心业务 -->
    <section class="pro-show2">
      <h2 class="section-title">四大核心业务</h2>
      <div class="max-w-6xl">
          <h2 class="mt-2 text-3xl md:text-4xl font-bold text-[#0E1F52] text-center">数字化转型 | 数据治理 | 审计风控合规 | AI大模型  <br>数字人才培训（数据及AI）</h2>
          <p class="mt-5 mb-5 text-[#5A5E66]"><i><strong>公司提供主要核心业务：</strong> </i>数字化转型咨询规划、数据管理体系咨询建设、审计风控合规产品、AI及大模型领域数据应用，数字化及 AI领域的教育培训业务。服务部门为企业IT、数据部、财务部、审计部、风险管理部、合规部、法务部等。</p>
      </div>

      <div class="core-line">
          <!-- 咨询业务 -->
          <transition name="el-zoom-in-center">
              <div class="core-box" v-show="show">
                  <div class="core-content">
                      <h1 class="text-2xl font-bold text-[#0E1F52] mb-2"> 核心业务一：数字化转型咨询</h1>
                      <p>针对Top 1500公司，提供战略及业务咨询，数字化应用规划，早期原型，POC/MVP，企业规模数字化交付，增加数字化产品体验。协助客户构建数字化实验室，提供必要的技术，产品，数据，分析及各类能力，帮助客户提升数字化交付力。</p>
                  </div>
                  <div class="core-link-wrapper">
                    <router-link to="/consulting/digital-transformation" class="core-link">了解数字化转型、IT规划 →</router-link>
                  </div>
              </div>   
          </transition>

          <!-- 数据治理咨询 -->
          <transition name="el-zoom-in-center">
              <div class="core-box" v-show="show">
                  <div class="core-content">
                      <h1 class="text-2xl font-bold text-[#0E1F52] mb-2"> 核心业务二：数据治理咨询</h1>
                      <p>提供企业级数据管理体系咨询服务，包括：数据战略咨询规划、数据分类分级、主数据管理、数据标准建设、数据质量管理、组织保障、DCMM数据管理成熟度评估及数字化转型成熟度评估。</p>
                  </div>
                  <div class="core-link-wrapper">
                    <router-link to="/consulting/data-governance" class="core-link">了解数据治理、数据管理体系建设 →</router-link>
                  </div>
              </div>
          </transition>
      </div>
      
      <div class="core-line">
          <!-- 03 审计风控合规 -->
          <transition name="el-zoom-in-center">
              <div class="core-box" v-show="show">
                  <div class="core-content">
                      <h1 class="text-2xl font-bold text-[#0E1F52] mb-2"> 核心业务三：审计风控合规法务</h1>
                      <p>主要围绕大审计、大监督、大风控领域的产品及能力建设，包括：数字化审计平台、大数据审计模型、自主建模及分析工具、领导干部经济责任审计评价、RPA自动化、风险管理、内控合规及法务相关产品。</p>
                  </div>
                  <div class="core-link-wrapper">
                    <router-link to="/consulting/audit-risk-consulting" class="core-link">了解审计、风控及合规服务 →</router-link>
                  </div>
              </div>
          </transition>
          <!-- 04 AI及大模型（LLM） -->
          <transition name="el-zoom-in-center">
              <div class="core-box" v-show="show">
                  <div class="core-content">
                      <h1 class="text-2xl font-bold text-[#0E1F52] mb-2"> 核心业务四：AI及大模型（LLM）</h1>
                      <p>AI及大模型技术应用于数据管理、治理与分析领域，提供基于AI的数据管理、分析与治理产品或服务。AI及大模型应用于审计、风控、合规领域，提供AI审计、AI风控、AI合规领域的产品或服务。</p>
                  </div>
                  <div class="core-link-wrapper">
                    <router-link to="/consulting/ai-consulting" class="core-link">了解AI、人工智能、大语言模型（LLM ） →</router-link>
                  </div>
              </div>
          </transition>
      </div>
    </section>

    <!-- 05 合作伙伴 -->
    <section class="pro-show2">
      <h2 class="section-title">合作伙伴</h2>
      <!-- 05-01 客户所在行业：头部描述 -->
      <div class="max-w-5xl mx-auto">
        <h2 class="text-center mt-2 text-3xl font-bold text-[#0E1F52] mb-4">合作伙伴 | 客户案例</h2>
        <p class="mb-4 mt-4">致力于内部审计数字化，服务行业头部客户，提供审计的数据标准化，审计作业标准化，审计成果最大化的工具和产品的一站式服务供应商，满足客户的审计、风险管理以及合规需求。构建新型的智能审计系统，利用人工智能技术，构建一个平台，多数据源的生态产品。</p>
      </div>

      <!-- 05-02 客户所在行业：客户列表图片展示 -->
      <div class="pro-show3">
        <div class="partners-tabs max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-center gap-4 mb-6">
            <button 
              :class="['tab-btn', partnerActiveName === 'first' ? 'active' : '']" 
              @click="partnerActiveName = 'first'"
            >能源电力</button>
            <button 
              :class="['tab-btn', partnerActiveName === 'second' ? 'active' : '']" 
              @click="partnerActiveName = 'second'"
            >水利水电</button>
            <button 
              :class="['tab-btn', partnerActiveName === 'third' ? 'active' : '']" 
              @click="partnerActiveName = 'third'"
            >汽车行业</button>
          </div>

          <div v-show="partnerActiveName === 'first'" class="partnershow">
            <div class="show-box" v-for="(img, index) in nydlImages" :key="index">
              <img :src="img" oncontextmenu="return false;" ondragstart="return false;"/>
            </div>
          </div>

          <div v-show="partnerActiveName === 'second'" class="partnershow">
            <div class="show-box" v-for="(img, index) in slsdImages" :key="index">
              <img :src="img" oncontextmenu="return false;" ondragstart="return false;"/>
            </div>
          </div>

          <div v-show="partnerActiveName === 'third'" class="partnershow">
            <div class="show-box" v-for="(img, index) in qchyImages" :key="index">
              <img :src="img" oncontextmenu="return false;" ondragstart="return false;"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- =====06  动态 + 新闻 ===== -->
    <section class="pro-show2">
        <h2 class="section-title">动态 + 新闻</h2>
        
        <!-- Tab 切换 -->
        <div class="news-tabs">
            <button
            :class="['tab-btn', activeName === 'first' ? 'active' : '']"
            @click="activeName = 'first'"
            >古杉动态</button>
            <button
            :class="['tab-btn', activeName === 'second' ? 'active' : '']"
            @click="activeName = 'second'"
            >媒体报道</button>
        </div>
        <!-- 古杉动态 -->
        <div v-show="activeName === 'first'" class="news-grid">
            <div
            class="news-card"
            v-for="(item, index) in dynamicList"
            :key="'dynamic-' + index"
            >
            <div class="news-card-image">
                <img :src="item.image" :alt="item.title" />
            </div>
            <div class="news-card-content">
                <h3 class="news-card-title">{{ item.title }}</h3>
                <p class="news-card-summary">{{ item.summary }}</p>
                <a :href="item.link" target="_blank" class="news-card-link">
                查看详情
                <span class="arrow">→</span>
                </a>
            </div>
            </div>
        </div>
        <!-- 媒体报道 -->
        <div v-show="activeName === 'second'" class="news-grid">
            <div
            class="news-card"
            v-for="(item, index) in mediaList"
            :key="'media-' + index"
            >
            <div class="news-card-image">
                <img :src="item.image" :alt="item.title" />
            </div>
            <div class="news-card-content">
                <h3 class="news-card-title">{{ item.title }}</h3>
                <p class="news-card-summary">{{ item.summary }}</p>
                <a :href="item.link" target="_blank" class="news-card-link">
                查看详情
                <span class="arrow">→</span>
                </a>
            </div>
            </div>
        </div>
    </section>

    <!-- ===== 07 行业解决方案矩阵 ===== -->
    <section class="pro-show2">
      <h2 class="section-title">古杉 能源 制造 解决方案矩阵</h2>
      <div class="pro-show4">
          <div>
              <h2 class="text-center mt-2 text-3xl font-bold text-[#0E1F52] mb-4"> 服务六大重点行业 </h2>
              <p class="mt-4 text-lg text-[#5A5E66]">公司服务头部央企国企及集团企业，目标为能源、电力、制造、水利水电、国资央企、集团型企业等领域的头部客户。当前服务过的客户包括但不限于国家电网、中国石化、中国电建、福田戴姆勒、浪潮信息、五大发电集团、戴姆勒奔驰等。</p>
          </div>
          <div class="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">⚡</span><span class="font-medium text-[#0E1F52]">能源</span><p class="text-xs text-[#5A5E66] mt-1">Agent·AI 审计 风控 合规</p></div>
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">🔌</span><span class="font-medium text-[#0E1F52]">电力</span><p class="text-xs text-[#5A5E66] mt-1">数据治理·数据管控·风控</p></div>
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">💧</span><span class="font-medium text-[#0E1F52]">水利水电</span><p class="text-xs text-[#5A5E66] mt-1">生产数据治理·碳审计</p></div>
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">🏭</span><span class="font-medium text-[#0E1F52]">制造</span><p class="text-xs text-[#5A5E66] mt-1">数据治理、主数据管理、经营管理分析</p></div>
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">🏛️</span><span class="font-medium text-[#0E1F52]">国资央企</span><p class="text-xs text-[#5A5E66] mt-1">数字化审计·合规</p></div>
              <div class="bg-[#F6F8FC] p-6 rounded-xl text-center border border-divider hover:border-[#1F3F8F] transition"><span class="text-4xl block mb-2">🏢</span><span class="font-medium text-[#0E1F52]">集团型企业</span><p class="text-xs text-[#5A5E66] mt-1">管控·数据治理</p></div>
          </div>
            <div class="text-center mt-12">
              <router-link to="/industry" class="inline-flex items-center px-6 py-3 border border-[#1F3F8F] text-brand bg-white rounded-md hover:bg-porcelain transition">查看全部行业解决方案 →</router-link>
            </div>
      </div>
    </section>

    <!-- ===== 06 标杆客户案例 ===== -->
    <section class="pro-show2">
      <h2 class="section-title">标杆客户案例</h2>
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="max-w-5xl mx-auto">
              <h2 class="text-center mt-2 text-3xl font-bold text-[#0E1F52] mb-4">  行业领军者的共同选择 </h2>
              <p class="mt-4 text-[#5A5E66]">服务100+央国企及集团公司，累计实施10+数据治理咨询项目、30+ 智慧审计项目、35+风险管理项目、50+合规管理项目、25+AI及大模型应用项目、数字化教育培训项目68+个。</p>
          </div>
          <div class="mt-8 grid md:grid-cols-2 gap-8">
              <!-- 案例1：银行 -->
              <div class="bg-white p-8 rounded-2xl border border-divider card-hover hover:border-[#1F3F8F] flex flex-col">
                  <div class="flex items-start gap-5 flex-grow">
                      <span class="w-14 h-14 bg-porcelain rounded-full flex items-center justify-center text-3xl flex-shrink-0">🏦</span>
                      <div class="flex-grow">
                          <span class="inline-block text-xs text-brand bg-porcelain px-3 py-1 rounded-full mb-2">银行 · 智能审计</span>
                          <h3 class="text-2xl font-bold text-[#0E1F52]">某国有大行 · 审计平台</h3>
                          <p class="mt-3 text-[#5A5E66] text-sm leading-relaxed">建设全行非现场审计平台，部署300+审计模型，覆盖信贷、结算、风险等12条业务线。审计覆盖率从15%提升至85%，问题发现效率提高70%。</p>
                      </div>
                  </div>
              </div>
              <!-- 案例2：保险 -->
              <div class="bg-white p-8 rounded-2xl border border-divider card-hover hover:border-[#1F3F8F] flex flex-col">
                  <div class="flex items-start gap-5 flex-grow">
                      <span class="w-14 h-14 bg-porcelain rounded-full flex items-center justify-center text-3xl flex-shrink-0">🛡️</span>
                      <div class="flex-grow">
                          <span class="inline-block text-xs text-brand bg-porcelain px-3 py-1 rounded-full mb-2">保险 · 实时风控</span>
                          <h3 class="text-2xl font-bold text-[#0E1F52]">中国人寿 · 风控体系</h3>
                          <p class="mt-3 text-[#5A5E66] text-sm leading-relaxed">构建实时风险指标监测平台，覆盖理赔、退保、给付等核心环节。建立200+风险规则库，年拦截风险交易超2万笔，挽回资金损失3.5亿元。</p>
                      </div>
                  </div>
              </div>
              <!-- 案例3：能源 -->
              <div class="bg-white p-8 rounded-2xl border border-divider card-hover hover:border-[#1F3F8F] flex flex-col">
                  <div class="flex items-start gap-5 flex-grow">
                      <span class="w-14 h-14 bg-porcelain rounded-full flex items-center justify-center text-3xl flex-shrink-0">⚡</span>
                      <div class="flex-grow">
                          <span class="inline-block text-xs text-brand bg-porcelain px-3 py-1 rounded-full mb-2">能源 · 数据治理</span>
                          <h3 class="text-2xl font-bold text-[#0E1F52]">国家能源集团 · 治理体系</h3>
                          <p class="mt-3 text-[#5A5E66] text-sm leading-relaxed">完成集团级数据治理蓝图，建立统一数据标准与指标库，主数据平台覆盖煤炭、电力、新能源等10+业务板块，通过DCMM四级认证。</p>
                      </div>
                  </div>
              </div>
              <!-- 案例4：央企集团 -->
              <div class="bg-white p-8 rounded-2xl border border-divider card-hover hover:border-[#1F3F8F] flex flex-col">
                  <div class="flex items-start gap-5 flex-grow">
                      <span class="w-14 h-14 bg-porcelain rounded-full flex items-center justify-center text-3xl flex-shrink-0">🏛️</span>
                      <div class="flex-grow">
                          <span class="inline-block text-xs text-brand bg-porcelain px-3 py-1 rounded-full mb-2">央企集团 · 数字化转型</span>
                          <h3 class="text-2xl font-bold text-[#0E1F52]">某央企集团 · 转型规划</h3>
                          <p class="mt-3 text-[#5A5E66] text-sm leading-relaxed">完成集团数字化顶层设计，制定三年实施路线图。统筹15家二级单位的数据治理与平台建设，形成集团统一的数据架构与管控体系。</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <!-- ===== 07 研究洞察 ===== -->
    <section class="pro-show2">
      <h2 class="section-title">研究洞察</h2>
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="max-w-5xl mx-auto">
              <h2 class="text-center mt-2 text-3xl font-bold text-[#0E1F52] mb-4">  数据社区 · 《数据决策与企业数字化转型》 </h2>
              <p class="mt-4 text-lg text-[#5A5E66]">数据社区：《数据决策与企业数字化转型》，分享数据管理、治理、数据分析、数据资产入表、数据合规出境、AI及大模型应用实践、审计、风险管理、监管风控领域的最新思想及最佳实践。同步，组织线上、线下的各社群。</p>
          </div>
          <div class="mt-16 grid md:grid-cols-3 gap-8">
              <!-- 文章1 -->
              <div class="bg-white p-6 rounded-xl border border-divider card-hover hover:border-[#1F3F8F]">
                  <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">数据治理</span>
                  <h3 class="mt-4 text-xl font-bold text-[#0E1F52]">央企数据治理的五大误区</h3>
                  <p class="mt-3 text-sm text-[#5A5E66]">很多央企在数据治理推进中会陷入"重技术轻管理"、"标准不落地"等典型误区...</p>
                  <router-link to="/research" class="mt-4 inline-block text-brand text-sm font-medium">阅读全文 →</router-link>
              </div>
              <!-- 文章2 -->
              <div class="bg-white p-6 rounded-xl border border-divider card-hover hover:border-[#1F3F8F]">
                  <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">审计数字化</span>
                  <h3 class="mt-4 text-xl font-bold text-[#0E1F52]">从人工审计到智能审计</h3>
                  <p class="mt-3 text-sm text-[#5A5E66]">非现场审计、持续审计、智能审计，三种模式的演进与实施要点...</p>
                  <router-link to="/research" class="mt-4 inline-block text-brand text-sm font-medium">阅读全文 →</router-link>
              </div>
              <!-- 文章3 -->
              <div class="bg-white p-6 rounded-xl border border-divider card-hover hover:border-[#1F3F8F]">
                  <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">风控体系</span>
                  <h3 class="mt-4 text-xl font-bold text-[#0E1F52]">实时风控的技术架构</h3>
                  <p class="mt-3 text-sm text-[#5A5E66]">从T+1到实时，企业风控体系如何实现秒级响应...</p>
                  <router-link to="/research" class="mt-4 inline-block text-brand text-sm font-medium">阅读全文 →</router-link>
              </div>
          </div>
            <div class="text-center mt-12">
              <router-link to="/research" class="inline-flex items-center text-brand font-medium">查看全部文章 →</router-link>
            </div>
      </div>
    </section>

    <!-- ===== 09 行动转化区 CTA ===== -->
    <section class="cta-section">
      <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 class="text-4xl font-bold">开启央国企、集团企业数字化转型之旅</h2>
          <p class="mt-5 text-lg opacity-90">预约专家咨询，获取定制化解决方案</p>
          <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <router-link to="/appointment" class="inline-block px-10 py-4 bg-white text-brand rounded-md text-lg font-semibold hover:bg-porcelain transition shadow-lg">预约咨询 →</router-link>
          </div>
          <p class="mt-8 text-sm opacity-75">1小时内响应 · 资深顾问一对一服务 · 严格保密</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() { 
    return { 
        show: true,
        activeName: 'first', // 用于动态+新闻的tab切换   
        partnerActiveName: 'first',    // 新增：用于合作伙伴的tab切换
        
        // tabs for partners carousel
        nydlImages: [],
        slsdImages: [],
        qchyImages: [],

        // 古杉动态数据 - 从原来的 honourData 转换
        dynamicList: [
        {
            title: '基于风险导向的、持续性的智慧审计',
            summary: '2018年以来，国家提出科技强审，审计监督，强化风险管控，促进央企合规为时代大的背景。该需求出现涉及3个主要因素：',
            image: require('@/assets/img/dynamic/news/news1.jpeg'),
            link: 'https://mp.weixin.qq.com/s/g-oEy50UhTVR-SD9DETIWA'
        },
        
        {
            title: '数字化智慧审计建设',
            summary: '古杉数据，成立于2017年，致力于内部审计数字化，服务行业头部客户，提供审计数据标准化，审计作业标准化',
            image: require('@/assets/img/dynamic/news/news2.jpeg'),
            link: 'https://mp.weixin.qq.com/s/eTc-9FRRcWpqQf6JzG_J1w'
        },

        {
            title: '数字化转型中的内部审计——顺应潮流，开启转型之路',
            summary: '加快数字化发展，建设数字中国、智慧审计、已经成为“十四五”规划和2035年远景目标纲要的重要内容',
            image: require('@/assets/img/dynamic/news/news4.jpeg'),
            link: 'https://mp.weixin.qq.com/s/ds6mMDVk1oHHIqAUvXd5pA'
        },
        {
            title: '古杉数据发布新版审计平台',
            summary: '古杉数据正式发布新版智能审计平台5.0，集成了AI大模型能力，审计效率提升超过50%。',
            image: require('@/assets/img/dynamic/news/news3.jpeg'),
            link: 'https://mp.weixin.qq.com/s/ds6mMDVk1oHHIqAUvXd5pA'
        }
        ],
        
        // 媒体报道数据 - 从原来的 newsData 转换
        mediaList: [
        {
            title: '基于风险导向的、持续性的智慧审计',
            summary: '智慧审计体系建设，包括审计监督评价、审计智能平台、AI智能评价画像、审计成果最大化等，覆盖央企国企的审计数字化全场景。',
            image: require('@/assets/img/dynamic/honour/news5.jpeg'),
            link: 'https://mp.weixin.qq.com/s/g-oEy50UhTVR-SD9DETIWA'
        },
        {
            title: '数字化智慧审计建设',
            summary: '通过大数据审计、审计信息化智能系统产品，实现审计监督预警，构建未来新型智能审计系统，减少企业2/3的审计成本。',
            image: require('@/assets/img/dynamic/honour/news5.jpeg'),
            link: 'https://mp.weixin.qq.com/s/eTc-9FRRcWpqQf6JzG_J1w'
        },
        {
            title: '以下四种方法，培养企业战略洞察力',
            summary: '深思、换位思考、观察行为、跨行业学习——四种方法帮助企业培养战略洞察力，创造竞争优势，实现高于竞争对手的财务表现。',
            image: require('@/assets/img/dynamic/honour/news5.jpeg'),
            link: 'https://mp.weixin.qq.com/s/XXlxsF-dYOZmUpfd8UEjaw'
        },
        {
            title: '数字化转型中的内部审计——顺应潮流，开启转型之路',
            summary: '探讨企业内部审计数字化转型的背景、多路径实施方案及工作要点，通过审计数字化转型助力企业数字化发展。',
            image: require('@/assets/img/dynamic/honour/news5.jpeg'),
            link: 'https://mp.weixin.qq.com/s/ds6mMDVk1oHHIqAUvXd5pA'
        }
        ],
        
        // 保留原来的数据以防其他地方使用
        newsData: [],
        honourData: [],
        newsMap: {},
        honourMap: {}
    } 
  },

  created() {
    const loadImages = (context) => context.keys().map(k => {
      const m = context(k)
      return (m && m.default) ? m.default : m
    })
    // 使用 try/catch 防止目录不存在时报错
    try {
      const nydlCtx = require.context('@/assets/img/partners/nydl', false, /\.(png|jpe?g|svg)$/)
      this.nydlImages = loadImages(nydlCtx)
    } catch (e) { console.warn('nydl images not found', e) }
    try {
      const slsdCtx = require.context('@/assets/img/partners/slsd', false, /\.(png|jpe?g|svg)$/)
      this.slsdImages = loadImages(slsdCtx)
    } catch (e) { console.warn('slsd images not found', e) }
    try {
      const qchyCtx = require.context('@/assets/img/partners/qchy', false, /\.(png|jpe?g|svg)$/)
      this.qchyImages = loadImages(qchyCtx)
    } catch (e) { console.warn('qchy images not found', e) }
  },
  methods: {
    handleSubmit() {
      alert('表单提交功能待实现')
    }
  }
}
</script>

<style scoped>
/* ========== 青花瓷色系变量 ========== */
.home-page {
  --brand-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --porcelain-blue: #EAF0FB;
  --ink-blue-gray: #2B2F3A;
  --white: #FFFFFF;
  --gray-bg: #F6F8FC;
  --divider: #E6EAF2;
}

/* ========== 公共工具类 ========== */
.bg-por { 
  background-color: var(--porcelain-blue); 
}

.bg-brand { 
  background-color: var(--brand-blue); 
}

.text-brand { 
  color: var(--brand-blue); 
}

.border-divider { 
  border-color: var(--divider); 
}

/* ========== 卡片通用悬浮效果 ========== */
.card-hover { 
  transition: all 0.25s; 
}

.card-hover:hover {
  box-shadow: 0 20px 30px -10px rgba(31, 63, 143, 0.08);
  border-color: transparent;
}

/* ========== 渐变背景 ========== */
.gradient-blue {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
}

.gradient-light {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
}

/* ========== 区块入场动画 ========== */
.section-left {
  margin-bottom: 5px;
  scroll-margin-top: calc(var(--nav-height) + 20px);
  opacity: 1;
  transform: translateY(15px);
  animation: sectionFadeIn 0.5s ease-in-out forwards;
}

/* ========== 核心能力展示区 ========== */
.pro-show2 { 
  max-width: 1200px;
  margin: 0 auto; 
  padding: 32px 16px; 
}

/* 核心业务行 - 使用Flex布局 */
.core-line { 
  display: flex; 
  gap: 20px; 
  margin-bottom: 24px; 
}
@media (max-width: 768px) {
  .core-line {
    flex-direction: column;
  }
}

/* 核心业务卡片 */
.core-box { 
  flex: 1 1 calc(50% - 10px);
  background: #fff; 
  padding: 28px 24px 24px;
  border-radius: 12px; 
  border: 1px solid var(--divider); 
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.04); 
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
}


/* 卡片悬浮效果 */
.core-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -10px rgba(31, 63, 143, 0.15);
  border-color: var(--brand-blue);
}

/* 卡片内容区域 - 占满剩余空间 */
.core-content {
  flex: 1;
}

.core-content h1 {
  font-size: 1.35rem; 
  color: var(--deep-indigo); 
  margin-bottom: 16px;  
  display: flex;
  align-items: center;
  gap: 8px;
}

.core-content p { 
  color: var(--ink-blue-gray); 
  font-size: 0.95rem; 
  line-height: 1.7;
  margin-bottom: 24px; 
}

/* 链接包装器 - 右下角定位 */
.core-link-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid var(--divider);
}


/* 链接样式 */
.core-link {
  display: inline-flex;
  align-items: center;
  color: var(--brand-blue);
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: none;
  padding: 6px 0;
  transition: all 0.2s ease;
  position: relative;
}


.core-link:hover {
  color: var(--deep-indigo);
  transform: translateX(4px);
}

.core-link::after {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--brand-blue);
  transition: width 0.3s ease;
}

.core-link:hover::after {
  width: 100%;
}

/* 动画效果 */
.el-zoom-in-center-enter-active,
.el-zoom-in-center-leave-active {
  transition: all 0.3s;
}

.el-zoom-in-center-enter {
  opacity: 0;
  transform: scale(0.95);
}

.el-zoom-in-center-enter-to {
  opacity: 1;
  transform: scale(1);
}

/* 响应式调整 */
@media (max-width: 480px) {
  .core-box {
    padding: 20px 16px;
  }
  
  .core-content h1 {
    font-size: 1.2rem;
  }
}

/* ========== 合作伙伴 ========== */
.partners-tabs .tab-btn {
  padding: 8px 16px;
  border-radius: 9999px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--deep-indigo);
  cursor: pointer;
  font-weight: 600;
}

.partners-tabs .tab-btn.active {
  background: var(--brand-blue);
  color: #fff;
  border-color: var(--brand-blue);
}

.partnershow {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.partnershow .show-box {
  width: 120px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid var(--divider);
}

.partnershow .show-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* ========== 区块标题（替代 h2-1 自定义标签） ========== */
.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #1F3F8F;
  border-radius: 4px;
}

/* ========== 动态新闻区域 - 新样式 ========== */
.news-tabs {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
}

.news-tabs .tab-btn {
  padding: 10px 24px;
  border-radius: 40px;
  border: 1px solid var(--divider);
  background: white;
  color: var(--deep-indigo);
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
}

.news-tabs .tab-btn:hover {
  border-color: var(--brand-blue);
  color: var(--brand-blue);
}

.news-tabs .tab-btn.active {
  background: var(--brand-blue);
  color: white;
  border-color: var(--brand-blue);
}

/* 新闻卡片网格 - 使用Flex布局 */
.news-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}

/* 新闻卡片 */
.news-card {
  width: calc(25% - 18px); /* 4列布局，减去gap */
  min-width: 260px;
  background: white;
  border: 1px solid var(--divider);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 卡片悬浮效果 */
.news-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -10px rgba(31, 63, 143, 0.15);
  border-color: transparent;
}

.news-card:hover .news-card-image img {
  transform: scale(1.05);
}

/* 图片区域 */
.news-card-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
  border-bottom: 1px solid var(--divider);
}

.news-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

/* 内容区域 - Flex纵向布局 */
.news-card-content {
  padding: 20px 16px 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 标题 - 2行截断 */
.news-card-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--deep-indigo);
  line-height: 1.4;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 50px;
}

/* 摘要 - 3行截断 */
.news-card-summary {
  font-size: 14px;
  color: var(--ink-blue-gray);
  line-height: 1.6;
  margin: 0 0 20px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/* 链接 - 固定在底部，带边框 */
.news-card-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--divider);
  color: var(--brand-blue);
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s;
  margin-top: auto;
}

.news-card-link .arrow {
  transition: transform 0.2s;
}

.news-card-link:hover {
  color: var(--deep-indigo);
}

.news-card-link:hover .arrow {
  transform: translateX(4px);
}

/* 响应式调整 */
@media (max-width: 1024px) {
  .news-card {
    width: calc(33.333% - 16px);
  }
}

@media (max-width: 768px) {
  .news-card {
    width: calc(50% - 12px);
  }
}

@media (max-width: 480px) {
  .news-card {
    width: 100%;
  }
}

/* ========== CTA 区域 ========== #0f2a2a   rgba(0, 40, 40, 0.06)  */
.cta-section {
  padding: 80px 0;
  background: #f8fafc;
  color: #0E1F52;
}

/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {   
  background: white;
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: #D4AF37;
  color: #1e3c3c;
}


/* H1 has already been added by Mar-7th,2026*/

/* 标题尺寸 */
h1 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
    color: #0b1a33;
}

</style>